import { Icon, type IconName } from '@/components/icons/icon'
import { cn } from '@/lib/utils'

const SIZES = {
  sm: 'size-8 rounded-[9px] [&>svg]:size-4',
  md: 'size-10 rounded-[11px] [&>svg]:size-[18px]',
  lg: 'size-[52px] rounded-[15px] [&>svg]:size-6',
} as const

interface IconTileProps {
  icon: IconName
  /** Cool means handled; warm means urgent or at risk. Never warm for decoration. */
  tone?: 'cool' | 'warm'
  size?: keyof typeof SIZES
  className?: string
}

/** A gradient tile holding one line icon: the cool or warm sweep from the mark. */
export function IconTile({ icon, tone = 'cool', size = 'md', className }: IconTileProps) {
  return (
    <span aria-hidden="true" className={cn('icon-tile', tone === 'warm' && 'warm', SIZES[size], className)}>
      <Icon name={icon} />
    </span>
  )
}
